export const toggleAppLogin = (route) => {
    console.log('toggleAppLogin', window.dataApi);
    if (typeof window.dataApi?.toggleAppLogin !== 'function') {
        return;
    }

    return window.dataApi.toggleAppLogin({value: route});
};
